import { Avatar, IconButton, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { HeaderContainer } from "../styleComponents/HeaderStyle";
import { HamburgerIcon } from "@chakra-ui/icons";
import { useSelector, useDispatch } from "react-redux";
import { AiOutlineLogout, AiOutlineHome, AiOutlineApartment } from 'react-icons/ai';
import { FiUsers } from 'react-icons/fi';
import { removeToken } from "../utils/tokenStorge";
import { Link, useNavigate } from "react-router-dom";
import { formatFullName, formatDisplayName } from "../utils/nameFormatter";

const PRIMARY = '#133654';

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { user = {}, activeRole } = useSelector(s => s);
    const logOut = () => {
        removeToken();
        dispatch({ type: "SET_USER", payload: {} });
        // Add a small delay to ensure state is updated before navigation
        setTimeout(() => {
            navigate('/login');
        }, 100);
    }

    // Show department name for all department heads (role=2) on all pages
    const isDepartmentHead = user?.role === 2;

    // Format department name for display
    const formatDepartmentName = (name) => {
        if (!name) return '';
        // Replace O'quv bo'limi with O'quv-uslubiy boshqarma for display
        if (name.toLowerCase().includes("o'quv") || name.toLowerCase().includes("oquv")) {
            return "O'quv-uslubiy boshqarma";
        }
        // Replace Ta'lim sifati bo'limi with Ta'lim sifatini nazorat qilish bo'limi for display
        if (name.toLowerCase().includes("ta'lim sifati") || name.toLowerCase().includes("talim sifati")) {
            return "Ta'lim sifatini nazorat qilish bo'limi";
        }
        // Replace Tarmoq texnologiyalari with Raqamli ta'lim texnologiyalari, mahalliy va xalqaro reyting bilan ishlash bo'limi for display
        if (name.toLowerCase().includes("tarmoq texnologiyalari")) {
            return "Raqamli ta'lim texnologiyalari, mahalliy va xalqaro reyting bilan ishlash bo'limi";
        }
        // Replace Ma'naviyat bo'limi with Yoshlar bilan ishlash, ma'naviyat va ma'rifat, Axborot-resurs markazi bo'limi for display
        if (name.toLowerCase().includes("ma'naviyat") || name.toLowerCase().includes("manaviyat")) {
            return "Yoshlar bilan ishlash, ma'naviyat va ma'rifat, Axborot-resurs markazi bo'limi";
        }
        // Replace Ilmiy bo'lim with full name for display
        if (name.toLowerCase().includes("ilmiy bo'lim")) {
            return "Ilmiy tadqiqotlar, innovatsiyalar ilmiy-pedagogik kadrlarni tayyorlash va iqtidorli talabalar bo'limi";
        }
        return name;
    };

    const shouldShowDepartmentName = isDepartmentHead && user?.partition?.name;
    const departmentName = shouldShowDepartmentName ? formatDepartmentName(user.partition.name) : '';

    return (<>
        <HeaderContainer>
            <Link to='/home'> <img src='/logot.png' alt="logo" className="logo" /></Link>
            <div className="title">KPI SYSTEM</div>
            {shouldShowDepartmentName && (
                <Text
                    textAlign="center"
                    fontWeight={600}
                    fontSize={{ base: "xs", md: "md" }}
                    color="white"
                    mt={2}
                    display={{ base: "none", md: "block" }}
                    style={{ position: 'absolute', left: '50%', top: '75px', transform: 'translateX(-50%)' }}
                >
                    {departmentName}
                </Text>
            )}
            <div className="right">
                {user?.id ?
                    <div className="user">
                        <Avatar
                            name={formatDisplayName(user?.first_name, user?.last_name)}
                            src={user?.avatar}
                            size={{ base: "sm", md: "md" }}
                        />
                        <div className="user_info">
                            <div className="name">{formatFullName(user?.first_name, user?.last_name, user?.middle_name) || 'Foydalanuvchi'}</div>
                            <div className="position">{user?.position}</div>
                        </div>
                    </div> : ''}
                <div>
                    <Menu>
                        <MenuButton
                            className="menu_btn"
                            as={IconButton}
                            aria-label='Options'
                            icon={<HamburgerIcon />}
                            variant='outline'
                        />
                        <MenuList bg={PRIMARY} color='white' borderColor='rgba(255,255,255,0.25)'>
                            <MenuItem as={Link} to='/' icon={<AiOutlineHome />} bg='transparent' color='white' _hover={{ bg: '#0f2a42' }}>
                                Bosh sahifa
                            </MenuItem>
                            {user?.role === 2 ? (
                                <>
                                    <MenuItem as={Link} to='/users' icon={<FiUsers />} bg='transparent' color='white' _hover={{ bg: '#0f2a42' }} >
                                        Hodimlar
                                    </MenuItem>
                                    {/* <MenuItem onClick={() => navigate('/kafedralar')} icon={<MdSchool />} bg='transparent' color='white' _hover={{ bg: '#0f2a42' }} >
                                Kafedralar
                            </MenuItem> */}
                                </>
                            ) : null}
                            {user?.role === 3 && (
                                <>
                                    <MenuItem
                                        bg='transparent'
                                        color='white'
                                        _hover={{ bg: 'transparent' }}
                                        cursor="default"
                                        fontWeight="bold"
                                        fontSize="sm"
                                        opacity={0.7}
                                    >
                                        Rol tanlash:
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            dispatch({ type: "SET_ACTIVE_ROLE", payload: 3 });
                                            navigate('/home');
                                        }}
                                        bg='transparent'
                                        color='white'
                                        _hover={{ bg: '#0f2a42' }}
                                        fontWeight={(activeRole || 3) === 3 ? 'bold' : 'normal'}
                                    >
                                        {(activeRole || 3) === 3 ? '✓ ' : '   '}Pro Rektor
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            dispatch({ type: "SET_ACTIVE_ROLE", payload: 2 });
                                            navigate('/home');
                                        }}
                                        bg='transparent'
                                        color='white'
                                        _hover={{ bg: '#0f2a42' }}
                                        fontWeight={(activeRole || 3) === 2 ? 'bold' : 'normal'}
                                    >
                                        {(activeRole || 3) === 2 ? '✓ ' : '   '}Bo'lim boshlig'i
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            dispatch({ type: "SET_ACTIVE_ROLE", payload: 1 });
                                            navigate('/home');
                                        }}
                                        bg='transparent'
                                        color='white'
                                        _hover={{ bg: '#0f2a42' }}
                                        fontWeight={(activeRole || 3) === 1 ? 'bold' : 'normal'}
                                    >
                                        {(activeRole || 3) === 1 ? '✓ ' : '   '}O'qituvchi
                                    </MenuItem>
                                </>
                            )}
                            <MenuItem icon={<AiOutlineLogout />} bg='transparent' color='white' _hover={{ bg: '#0f2a42' }} onClick={logOut}>
                                Tizimdan chiqish
                            </MenuItem>
                        </MenuList>
                    </Menu>
                </div>
            </div>
        </HeaderContainer>
    </>)
}
export default Header;